import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Button, Link, Modal, Typography } from '@material-ui/core';
import { Text } from 'recharts';
import { bindActionCreators } from 'redux';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { sendLogin, signOut } from '../../auth/Auth';
import GroupEditGroup from './GroupEditGroup';
import { removeToken } from '../../libs/apis/UserApi';
import { getGroupDetail } from '../../actions/Groups';
import { getOptionCities } from '../../actions/Cities';

const styles = theme => ({
  hidden: {
    display: 'none'
  },
  font12: {
    fontSize: 12
  },
  font14: {
    fontSize: 14
  },
  bold: {
    fontWeight: 'bold'
  },
  mt20: {
    marginTop: 20
  },
  page: {
    paddingTop: 20,
    paddingLeft: 15,
    paddingRight: 15
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(1)
  },
  titleGroup: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    alignItems: 'flex-start'
  },
  pagerInDiv: {
    padding: 20
  },
  redText: {
    color: '#FF0000'
  },
  tableTitle: {
    fontSize: 16,
    marginBottom: '20px'
  },
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #E0E0E0',
    backgroundColor: '#F7F7F7',
    width: '115px',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 700
  },
  tableCellData: {
    borderBottom: '1px solid #E0E0E0',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 500
  },
  noteText: {
    fontSize: 12,
    paddingTop: 10,
    fontWeight: 600
  },
  textLabel: {
    fontSize: 12,
    fontWeight: 600
  },
  description: {
    color: '#707070',
    fontSize: 14
  },
  shopInfoContainer: {
    width: '90%',
    margin: 'auto',
    paddingTop: 20,
    paddingBottom: 10,
    whiteSpace: 'nowrap'
  },
  shopHeader: {
    backgroundColor: '#717171 !important',
    height: 'auto',
    minHeight: 22,
    marginBottom: 10,
    display: 'flex',
    alignItems: 'center'
  },
  tableInfo: {
    width: '100%',
    marginBottom: 10
  },
  tableInfoCellHeader: {
    padding: '5px 10px',
    width: '60px',
    borderBottom: '2px solid #ffffff',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#000000',
    backgroundColor: '#F7F7F7',
    whiteSpace: 'nowrap'
  },
  tableInfoCell: {
    padding: '2px 10px',
    borderBottom: '2px solid transparent',
    fontSize: '12px',
    whiteSpace: 'break-spaces'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  tableRowShopName: {
    paddingLeft: 16
  },
  titleGroupNameDiv: {
    padding: '5px 12px'
  },
  titleGroupName: {
    fontSize: 10,
    fontWeight: 'normal',
    lineHeight: '13px',
    color: 'rgba(255, 255, 255, 0.87)'
  },
  textGroupNameDiv: {
    padding: '5px 12px'
  },
  textGroupName: {
    fontSize: 12,
    lineHeight: '16px',
    color: '#fff',
    whiteSpace: 'break-spaces'
  },
  textShopId: {
    fontSize: 10,
    fontWeight: 'normal',
    lineHeight: '13px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  textShopName: {
    fontWeight: 'bold',
    fontSize: 16,
    lineHeight: '21px',
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: 5,
    whiteSpace: 'break-spaces'
  },
  paperContentItem: {
    margin: '20px auto'
  },
  iconOpenDoc: {
    width: 16
  },
  helpLink: {
    display: 'flex',
    fontSize: 14
  },
  linkToHome: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20
  },
  modal: {
    maxWidth: 978,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators({ getGroupDetail, getOptionCities }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('groupDetail', 'setGroupDetail', {}),
  withState('cityId', 'setCityId', ''),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    account,
    show,
    handleRedirect,
    checkSession,
    updateOpenProgress,
    openEditModal,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    groupDetail,
    setGroupDetail,
    cityId,
    setCityId,
    listBank,
    listBankBranch
  }) => {
    const getGroup = async id => {
      await actions.getGroupDetail(id).then(groupData => {
        checkSession(groupData);
        setGroupDetail(groupData.payload);
        setCityId(groupData.payload.cityId);
      });
    };

    const editOpenAction = () => {
      updateOpenProgress(true);
      Promise.all([actions.getOptionCities(), getGroup(account.groupId)])
        .then(() => {
          updateOpenProgress(false);
          updateOpenEditModal(true);
        })
        .catch(() => {
          updateOpenProgress(false);
        });
    };

    const signOutAction = async () => {
      // remove token
      const currentToken = localStorage.getItem('firebaseToken');
      removeToken({
        pushToken: currentToken
      })
        .then(() => {
          console.log('remove token success');
        })
        .catch(() => {
          console.log('remove token failed');
        });

      signOut();
      handleRedirect('/');
    };

    return (
      <div className={show ? null : classes.hidden}>
        <div className={classes.page}>
          <div>
            <Typography className={classes.font14}>
              すべての情報が入力され、現在事務局審査中です。
            </Typography>
          </div>
          <div className={classes.titleGroup}>
            <Typography className={classes.font12}>
              ※審査はおおむね2〜3日程度で完了いたします。
            </Typography>
          </div>
          <div className={classes.titleGroup}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => handleRedirect('/release_group_review')}
            >
              審査状況を確認する
            </Button>
          </div>
          <Paper className={classes.paper} elevation={1}>
            <div className={classes.pagerInDiv}>
              <Typography className={classes.font14}>
                事務局審査中、グループ情報を登録・編集することが可能です。
              </Typography>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.mt20}
                onClick={editOpenAction}
              >
                グループ情報を登録・編集する
              </Button>
            </div>
          </Paper>
        </div>
        <div className={classes.paperContentItem}>
          <Link
            href="https://shop-guide.gochimeshi.com/"
            target="_blank"
            className={classes.helpLink}
          >
            サポートサイト
            <OpenInNewIcon className={classes.iconOpenDoc} />
          </Link>
        </div>
        <div className={classes.linkToHome}>
          <Button className={classes.button} onClick={signOutAction}>
            <Text className={[classes.bold, classes.font14]}>ログアウト</Text>
          </Button>
        </div>
        <Modal
          open={openEditModal}
          onClose={() => {
            updateOpenEditModal(false);
          }}
          className={classes.modal}
        >
          <GroupEditGroup
            updateOpenEditModal={updateOpenEditModal}
            openEditConfirm={openEditConfirm}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={groupDetail}
            setDisplayGroupName={() => {}}
            cityId={cityId}
            setCityId={setCityId}
            onEditSuccess={getGroup}
            listBank={listBank}
            listBankBranch={listBankBranch}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
